<script lang="ts">
  import Loading from '../../etc/loader.svelte';
  import { getContext } from 'svelte';
  import MaterialChange from '../../etc/modal/MaterialChangeModal.svelte';
  import TransferChange from '../../etc/modal/TransferModal.svelte';
  import BusinessChange from '../../etc/modal/BusinessChangeModal.svelte';
  import RepositoryFactory, { CONTRACT } from '../../repositories/RepositoryFactory';
  import type { GetContractResult } from '../../repositories/contract';
  import { loginUser } from '../../components/auth/LoginUser';
  import { push } from 'svelte-spa-router';

  const { open }: any = getContext('simple-modal');

  const showMaterial = () => {
    open(MaterialChange, {});
  };
  const showTransfer = () => {
    open(TransferChange, {});
  };
  const showBusiness = () => {
    open(BusinessChange, {});
  };

  let promise = (async () => {
    let contract: GetContractResult;
    const contractRepository = RepositoryFactory[CONTRACT];
    await contractRepository
      .getContract()
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        contract = res;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
          return false;
        } else {
          alert('エラーが発生しました。');
          throw new Error();
        }
      });
    return contract;
  })();

  const isTerminated = (contract: GetContractResult): boolean => {
    return contract.contractStatusCode === 'TERMINATED';
  };
</script>

<!-- 本体 -->
{#await promise}
  <Loading />
{:then contract}
  <div class="flex mb-4">
    <div class="rounded bg-white border-t-4 border-green-400">
      <div class="shadow rounded-lg bg-gray-50 border-1 p-4 mb-10">
        <div class="flex flex-col divide-y divide-gray-300">
          <div class="flex-1 flex flex-col divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">品目変更</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span> ファミリータイプ/マンションタイプの変更についてはこちら </span>
                </div>

                <div class="grid-1">
                  <button on:click={showMaterial} class="button-primary" disabled={isTerminated(contract)}>
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1 flex flex-col pt-20 divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">移転</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span class="">引っ越しなどにより住所変更の手続きはこちら</span>
                </div>

                <div class="grid-1">
                  <button on:click={showTransfer} class="button-primary" disabled={isTerminated(contract)}>
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1 flex flex-col pt-20 divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">事業者変更</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span class="">事業者変更の手続きはこちら</span>
                </div>

                <div class="grid-1">
                  <button on:click={showBusiness} class="button-primary" disabled={isTerminated(contract)}>
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/await}

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default bg-gray-400;
  }
</style>
